<template>
  <b-modal
    id="admin-modal"
    :title="
      readonly
        ? 'عرض بيانات المستخدم'
        : form.id
        ? 'تحديث بيانات مسؤول المصرف'
        : 'أضافة مسؤول مصرف'
    "
    shadow
    hide-footer
    :no-close-on-backdrop="true"
    @hidden="clearForm"
    size="lg"
    body-class="p-5"
  >
    <div class="px-3 py-2">
      <VForm v-slot="{ onValidate }">
        <VFileField
          v-model="form.image"
          label="الصورة الشخصيه"
          type=".jpg, .png"
          :disabled="readonly"
        ></VFileField>
        <b-row>
          <b-col>
            <VTextField
              v-model="form.name"
              label="أسم المستخدم"
              rules="required"
              :readonly="readonly"
            ></VTextField
          ></b-col>
          <b-col
            ><VTextField
              v-model="form.phone"
              label="رقم الهاتف"
              :rules="form.id ? 'required' : 'required|numeric'"
              :readonly="readonly"
              style="direction: ltr"
            ></VTextField
          ></b-col>
        </b-row>
        <b-row>
          <b-col
            ><VTextField
              v-model="form.email"
              label="البريد الألكتروني"
              rules="required"
              :readonly="readonly"
            ></VTextField
          ></b-col>
          <b-col>
            <VTextField
              v-model="form.password"
              type="password"
              label="كلمة المرور"
              :rules="form.id ? null : 'required'"
              :readonly="readonly"
            ></VTextField
          ></b-col>
        </b-row>
        <VSelectField
          v-model="form.bank_id"
          label="المصرف"
          :rules="form.id ? null : 'required'"
          :items="banks"
          :disabled="readonly"
        ></VSelectField>
        <b-row v-if="!readonly" class="pt-4">
          <b-col>
            <b-button
              :variant="form.id ? 'success' : 'info'"
              block
              @click="onValidate(action)"
              >{{ form.id ? "تحديث" : "أضافة" }}</b-button
            >
          </b-col>
          <b-col>
            <b-button
              variant="outline-info"
              block
              @click="$bvModal.hide('admin-modal')"
              >الغاء</b-button
            >
          </b-col>
        </b-row>
      </VForm>
    </div>
  </b-modal>
</template>

<script>
import { clearObject, successAlert, errorAlert } from "@/utils/helper";

export default {
  props: { readonly: Boolean },
  data() {
    return { banks: [] };
  },
  computed: {
    form: {
      get() {
        return this.$store.state.admin.admins.form;
      },
      set(value) {
        this.$store.commit("admin/admins/SET_ADMIN", value);
      },
    },
  },
  mounted() {
    this.$store.dispatch("admin/banks/getAll").then((response) => {
      response.forEach((item) => {
        this.banks.push({ value: item.id, text: item.name });
      });
    });
  },
  methods: {
    action() {
      var state = this.form.id ? "update" : "store";
      this.$store
        .dispatch(`admin/admins/${state}`)
        .then((response) => {
          successAlert();
          this.$bvModal.hide("admin-modal");
          this.$store.commit(
            `admin/admins/${state.toUpperCase()}_ADMIN`,
            response.payload
          );
        })
        .catch((error) =>
          errorAlert(
            error.response ? error.response.data.message : "حدثت مشكله"
          )
        );
    },
    clearForm() {
      this.form = clearObject(this.form);
      this.$emit("close");
    },
  },
};
</script>

<style>
td[aria-colindex="2"] {
  text-align: right;
}
td[aria-colindex="3"] {
  direction: ltr;
}
</style>
